// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"1":"c387481370fc18af5182","104":"6491e61b7d990ca6b73c","883":"79ad6bf5bd94b15ff0b0"}[chunkId] + ".chunk.js";
};